import React from 'react';
import { useParams } from 'react-router-dom';

import history from 'helpers/history';

import LogoContainer from 'containers/LogoContainer';
import Button from 'components/commons/Button';

import successImage from './assets/success.png';

import './SuccessfulPurchase.scss';

const SuccessfulPurchase = () => {
  const { guideNumber } = useParams();

  const onShippingLinkClick = () => {
    history.push(`/seguimiento-de-envio/${guideNumber}`);
  };

  return (
    <div className="container" data-testid="successful-purchase-page">
      <div className="row successful-purchase flex-column justify-content-center align-items-center text-center">
        <img src={successImage} alt="successful-purchase" className="successful-purchase-check" />
        <p className="successful-purchase-title">¡MUCHAS GRACIAS!</p>
        <p className="successful-purchase-title">¡Tu pedido fue realizado con &eacute;xito!</p>
        <p>
          <span>
            En pocos minutos se le estará enviando un mail a tu casilla de correo electr&oacute;nico
            {' '}
            con el detalle de tu pedido. Recordá verificar la carpeta de “SPAM” o
            “correo no deseado”.
          </span>
          <br />
          <span>
            En breve nos estaremos comunicando con vos para coordinar forma de pago
            {guideNumber ? '.' : ' y envío.'}
          </span>
          {guideNumber && (
            <>
              <br />
              <span>
                Su numero de envío es: <strong>{guideNumber}</strong>.
              </span>
              {' '}
              <span className="successful-purchase-shipping-link" onClick={onShippingLinkClick} role="presentation">
                Puede consultar el estado de su envío haciendo click acá.
              </span>
            </>
          )}
        </p>
        <p className="successful-purchase-title">Gracias por confiar en nosotros.</p>
        <div className="successful-purchase-logo">
          <LogoContainer />
        </div>
        <Button text="Volver al inicio" href="/home" />
      </div>
    </div>
  );
};

export default SuccessfulPurchase;
